import { render } from "./FailedConfirmAppointmentView.vue?vue&type=template&id=d3a52994&scoped=true"
const script = {}

import "./FailedConfirmAppointmentView.vue?vue&type=style&index=0&id=d3a52994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3a52994"]])

export default __exports__